import { entityBrowserConstants } from '../constants/entityBrowserConstants';

const initialState = {
    fetchingExpandedNodeIds: false,
    fetchingExpandedNodeIdsError: null,

    selectedNodeIds: [],
    expandedNodeIds: [],
};

export function entityBrowser(state = initialState, action) {
    switch (action.type) {
        case entityBrowserConstants.FETCH_EXPANDED_NODE_ID_REQUEST: {
            return {
                ...state,
                fetchingExpandedNodeIds: true,
            };
        }
        case entityBrowserConstants.FETCH_EXPANDED_NODE_ID_SUCCESS: {
            return {
                ...state,
                fetchingExpandedNodeIds: false,
                expandedNodeIds: action.expandedNodeIds,
            };
        }

        case entityBrowserConstants.FETCH_EXPANDED_NODE_ID_FAILURE: {
            return {
                ...state,
                fetchingExpandedNodeIds: false,
                fetchingExpandedNodeIdsError: action.error,
            };
            }
        case entityBrowserConstants.UPDATE_EXPANDED_NODE_ID_SUCCESS: {
            return {
                ...state,
                fetchingExpandedNodeIds: false,
                expandedNodeIds: action.updatedExpandedNodeIds,
            };
        }
        
        case entityBrowserConstants.UPDATE_SELECTED_NODE_ID_REQUEST: {
            return state; 
        }

        case entityBrowserConstants.UPDATE_SELECTED_NODE_ID_SUCCESS: {
            return {
            ...state,
            selectedNodeIds: action.updatedSelectedNodeIds,
        };
        }

        case entityBrowserConstants.UPDATE_SELECTED_NODE_ID_FAILURE: {
        return state; 
        }

    default: {
      return state;
    }
  }
}